export const normalizePicturePaths = (
  picturePaths: (string | null | undefined)[] | null | undefined
): string[] | null => {
  if (!picturePaths) return null;

  const paths = picturePaths.filter(
    (path): path is string => typeof path === "string" && path.length > 0
  );

  return paths.length > 0 ? paths : null;
};
